import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: localStorage.getItem('lngClassifier') || 'ru',
    fallbackLng: 'ru',
    ns: ['common', 'services', 'promptbar', 'diagnoses', 'classification'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      requestOptions: {
        cache: 'no-store',
      },
    },
  });

export default i18n;
